import { tv, type VariantProps } from '@/code/lib/tv';

export const navigationMenuVariants = tv({
  slots: {
    root: ['relative', 'z-10', 'flex', 'max-w-max', 'flex-1', 'items-center'],
    list: ['flex', 'flex-1', 'list-none', 'items-center', 'gap-1'],
    trigger: [
      'group',
      'inline-flex',
      'h-9',
      'w-max',
      'items-center',
      'justify-center',
      'gap-1.5',
      'rounded-lg',
      'border',
      'border-outline',
      'px-3',
      'py-2',
      'text-sm',
      'font-medium',
      'text-paragraph',
      'transition-colors',
      'hover:bg-surface-low',
      'hover:text-heading',
      'focus:outline-none',
      'data-[state=open]:bg-surface-low',
      'data-[state=open]:text-heading',
    ],
    link: [
      'inline-flex',
      'h-9',
      'w-max',
      'items-center',
      'justify-center',
      'gap-1.5',
      'rounded-lg',
      'border',
      'border-outline',
      'px-3',
      'py-2',
      'text-sm',
      'font-medium',
      'text-paragraph',
      'transition-colors',
      'hover:bg-surface-low',
      'hover:text-heading',
      'focus:outline-none',
    ],
    content: [
      'absolute',
      'right-0',
      'top-full',
      'mt-1.5',
      'z-50',
      'min-w-[12rem]',
      'overflow-hidden',
      'rounded-2xl',
      'border',
      'border-outline',
      'bg-popover',
      'p-1',
      'shadow-md',
      'data-[motion^=from-]:animate-in',
      'data-[motion^=to-]:animate-out',
      'data-[motion^=from-]:fade-in',
      'data-[motion^=to-]:fade-out',
      'data-[motion=from-start]:slide-in-from-left-2',
      'data-[motion=from-end]:slide-in-from-right-2',
    ],
    item: [
      'relative',
      'flex',
      'cursor-default',
      'select-none',
      'items-center',
      'gap-2',
      'rounded-xl',
      'px-2',
      'py-1.5',
      'h-9',
      'text-sm',
      'text-paragraph',
      'outline-none',
      'transition-colors',
      'hover:bg-surface-low',
      'focus:bg-surface-low',
    ],
    icon: ['size-4', 'text-subheading'],
    badge: [
      'inline-flex',
      'items-center',
      'justify-center',
      'rounded-full',
      'bg-error',
      'px-1.5',
      'py-0.5',
      'text-[10px]',
      'font-medium',
      'text-white',
      'leading-none',
      'ml-auto',
    ],
    chevron: [
      'relative',
      'top-px',
      'size-3',
      'transition-transform',
      'duration-200',
      'group-data-[state=open]:rotate-180',
    ],
  },
});

export type NavigationMenuVariants = VariantProps<
  typeof navigationMenuVariants
>;
